/* eslint-disable react-hooks/exhaustive-deps */
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDownFilter } from 'components/InputsMex/inputs';
import { FORMA_PAGO } from 'constants/formasPago';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import useParametrosPago from 'redux/hooks/useParametrosPago';
import '../styles.scss';
import ModalCoberturas from './ModalCoberturasMarineInland';

const ResumenDatosPlanMarineInland = ({
  tarifar,
  datosTarifacion,
  prod,
  cotizacion,
  recalculando,
}) => {
  const [showOpciones, setshowOpciones] = useState(false);

  const [showMesesVigencia, setShowMesesVigencia] = useState(false);

  const [showPagos, setShowPagos] = useState(false);
  const { parametros, setCombos, ...stateParametrosPago } = useParametrosPago();
  const [listadoOpcionesPago, setListadoOpcionesPago] = useState([]);

  const methods = useFormContext();

  const { getValues } = methods;

  const onChangeFormPago = (value) => {
    if (value.onChange === 'recalcular') {
      tarifar({ idPlazo: value.id, formaPago: value.tipo, labelPlazo: value.label });
    }
    setshowOpciones(value?.mostrarSubopciones);
  };

  const onChangePlazo = (value) => {
    const formaPago = getValues('formaPago');
    tarifar({
      idPlazo: value.ID,
      formaPago: formaPago.tipo,
      labelPlazo: value.Name,
    });
  };

  const onChangeVigencia = (value) => {
    setShowPagos(true);
    methods.setValue('mesesVigencia', null);
    if (value.value == '2' || value.value == 2) {
      setShowMesesVigencia(true);
      const formasPago = parametros?.formasPago?.filter((item) => item.value.idPlazo == '1');
      methods.reset({
        ...methods.getValues(),
        mesesVigencia: null,
        formaPago: formasPago?.[0]?.value,
      });
      setListadoOpcionesPago(formasPago);
      setshowOpciones(false);
    } else {
      setShowMesesVigencia(false);
      setListadoOpcionesPago(parametros?.formasPago);
      // Mandar a tarifar los valores

      let formaPagoData = methods.getValues('formaPago');
      const objTarifacion = {
        idPlazo: formaPagoData.id,
        formaPago: formaPagoData.tipo,
        labelPlazo: formaPagoData.label,
      };

      if (FORMA_PAGO.isMSI(formaPagoData.tipo)) {
        const plazoMsi = methods.watch('idPlazo');
        objTarifacion.idPlazo = plazoMsi.ID;
        objTarifacion.labelPlazo = plazoMsi.Name;
      }
      console.log('OBJ TARIFACION: ', objTarifacion);
      tarifar(objTarifacion);
    }
  };
  const onchangeMesesVigencia = (value) => {
    tarifar({ idPlazo: 1, formaPago: 'contado', labelPlazo: 'CONTADO' });
    setCombos({
      formaPago: 'contado',
      idPlazo: 1,
      setshowOpciones,
      reset: methods.reset,
      extraData: methods.getValues(),
    });
  };
  const onChangeDescuento = (value) => {
    let formaPagoData = methods.getValues('formaPago');
    tarifar({
      idPlazo: formaPagoData.id,
      formaPago: formaPagoData.tipo,
      labelPlazo: formaPagoData.label,
    });
  };

  useEffect(() => {
    if (parametros?.formasPago) {
      setListadoOpcionesPago(parametros?.formasPago);
      let precargaVigencia = cotizacion?.carContratante?.itemsGenerales?.vigencia;
      let precargaVigenciaMeses = cotizacion?.carContratante?.itemsGenerales?.mesesVigencia;
      let descuentoRecargo = cotizacion?.carContratante?.itemsGenerales?.descuentoRecargo;

      setCombos({
        formaPago: datosTarifacion.formaPago,
        idPlazo: datosTarifacion.idPlazo,
        setshowOpciones,
        reset: methods.reset,
        extraData: {
          vigencia: precargaVigencia,
          mesesVigencia: precargaVigenciaMeses,
          descuentoRecargo: descuentoRecargo,
        },
      });

      if (precargaVigencia) {
        setShowPagos(true);
      }
      if (precargaVigencia?.value == '2') {
        setShowMesesVigencia(true);
        setListadoOpcionesPago(parametros?.formasPago.filter((item) => item.value.idPlazo == '1'));
      }
    }
    console.log('cotizacion',cotizacion)
  }, [parametros]);
  return (
    <React.Fragment>
      <div className="col-10 col-md-6 border-mex-ap ">
        <div className="row">
          <div className="col-11 mt-5 mx-auto">
            <h2 className="font-mex text-center">¡Has elegido!</h2>

            <div className="row justify-content-center mt-3 mb-5">
              <div className="col-11 col-md-8 border-mex-ap text-center py-4">
                <div
                  className="text-center"
                  style={{
                    backgroundColor: '#c0e7f7',
                    fontSize: '20px',
                    paddingBottom: '1rem',
                    paddingTop: '0.3rem',
                    width: '100%',
                    margin: '0 0 0 0 ',
                    paddingLeft: '0',
                    paddingRight: '0',
                  }}
                >
                  <div className="font-mex mt-2 font-res-marine">
                    Seguro de equipo de contratista
                  </div>
                </div>
                <h1 className="font-mex res-text-value">
                  ${datosTarifacion?.primaNetaSinRecargoDescuento} {datosTarifacion.monedaSimbolo}
                </h1>
              </div>
            </div>
          </div>
          <div className="col-11 col-md-4">
            <div className="cl-res-datos-plan"></div>
          </div>
          <div className="col-11 col-md-7">
            <ModalCoberturas
              data={prod[0]?.coberturasAdicionalesSeleccionadas}
              moneda={datosTarifacion?.monedaSimbolo}
            />
          </div>
          <div className="row col-12 px-3">
            <div className="col-12 col-lg-6">
              <SimpleContainer label="Vigencia" name="vigencia">
                <DropDownFilter
                  name="vigencia"
                  optionLabel="label"
                  optionValue="value"
                  options={cotizacion?.vigenciasOpciones?.opcionesVigencia?.map((item) => ({
                    ...item,
                    label: item.label,
                    value: item,
                  }))}
                  rules={{ required: 'Este campo es obligatorio' }}
                  onChangeFn={onChangeVigencia}
                  loading={stateParametrosPago.loading}
                  loadingText={stateParametrosPago?.loading && 'Cargando...'}
                  disabled={recalculando}
                />
              </SimpleContainer>
            </div>
            <div className="col-12 col-lg-6">
              {showMesesVigencia && (
                <SimpleContainer label="Meses de vigencia" name="mesesVigencia">
                  <DropDownFilter
                    name="mesesVigencia"
                    optionLabel="label"
                    optionValue="value"
                    options={cotizacion?.vigenciasOpciones?.opcionesMenorAnio?.map((item) => ({
                      ...item,
                      label: item.label,
                      value: item,
                    }))}
                    rules={{ required: 'Este campo es obligatorio' }}
                    onChangeFn={onchangeMesesVigencia}
                    loading={stateParametrosPago.loading}
                    loadingText={stateParametrosPago?.loading && 'Cargando...'}
                    disabled={recalculando}
                  />
                </SimpleContainer>
              )}
            </div>
          </div>
          <div className="col-12 py-1 px-3">
            <div className="row">
              <div className="col-xl-6">
                {showPagos && (
                  <SimpleContainer
                    name="formaPago"
                    label="Opción de pago"
                    helpText={stateParametrosPago.loading && 'Cargando formas de pago...'}
                  >
                    <DropDownFilter
                      name="formaPago"
                      filter={false}
                      rules={{ required: 'Obligatorio' }}
                      options={listadoOpcionesPago}
                      onChangeFn={onChangeFormPago}
                      loading={stateParametrosPago.loading}
                      loadingText={stateParametrosPago?.loading && 'Cargando...'}
                      disabled={recalculando}
                    />
                  </SimpleContainer>
                )}
              </div>

              {showOpciones && (
                <div className="col-xl-6">
                  <SimpleContainer label="Elije cuántos meses" name="idPlazo">
                    <DropDownFilter
                      name="idPlazo"
                      filter={false}
                      rules={{ required: 'Obligatorio' }}
                      options={parametros.plazos}
                      onChangeFn={onChangePlazo}
                      loading={stateParametrosPago?.loading}
                    />
                  </SimpleContainer>
                </div>
              )}
            </div>
          </div>

          <div className="row col-12 px-3">
            <div className="col-12 col-lg-6">
              {cotizacion?.descuentoRecargo &&
                cotizacion?.descuentoRecargo.length > 0 &&
                showPagos && (
                  <SimpleContainer label="Descuento(-)/Recargo(+)" name="descuentoRecargo">
                    <DropDownFilter
                      name="descuentoRecargo"
                      optionLabel="label"
                      optionValue="value"
                      options={cotizacion?.descuentoRecargo.map((item) => ({
                        ...item,
                        label: item.label,
                        value: item,
                      }))}
                      onChangeFn={onChangeDescuento}
                    />
                  </SimpleContainer>
                )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResumenDatosPlanMarineInland;
